<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="title">引入图标</div>
        <div>在根目录下的index.html文件中引入外部字体图标css文件</div>
        <pre v-highlightjs="code3"><code class="html" ></code></pre>
        <div>使用i标签，统一加上iconfont类，再加上具体的图标类</div>
        <pre v-highlightjs="code4"><code class="html" ></code></pre>
        <div style="margin-bottom: 30px;">显示结果如下</div>
        <i class="iconfont icon-home"></i>
        <div style="margin-bottom: 30px"></div>

        <div class="icons-box">
          <div class="icons" v-for="item in icons">
            <i class="iconfont" :class="[item]"></i>
            <span>{{item}}</span>
          </div>
        </div>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Icon',
  data() {
    return {
      code1: `
      `,
      icons: ["icon-eye-close","icon-yutube","icon-yuren","icon-yahoo","icon-yuan","icon-wordress","icon-woman","icon-whatsapp","icon-wind","icon-window-add","icon-windows","icon-wechat","icon-weibo","icon-vip","icon-wallet","icon-visa","icon-file-wait","icon-user-wait","icon-user-search","icon-video","icon-user-round-wait","icon-user-round-close","icon-user-round-delete","icon-user-check","icon-user-round-check","icon-user-round-add","icon-user-close","icon-user-delete","icon-user-add","icon-upload","icon-usb","icon-up-circle","icon-up-chart","icon-twitter1","icon-undo","icon-tmall","icon-tv","icon-train","icon-tree","icon-taobao","icon-tencent-weibo","icon-system","icon-table","icon-stack-overflow","icon-small-rain","icon-sofa","icon-shopping-cart-full","icon-shopping-cart-o","icon-smile1","icon-slidebar","icon-file-search","icon-safari","icon-sad","icon-rank","icon-rocket","icon-right-circle","icon-refresh2","icon-refresh1","icon-red-pocket","icon-qrcode","icon-redo","icon-podcast","icon-qq","icon-pin-o","icon-phone-square","icon-pin","icon-phone-close-square","icon-phone-close-circle","icon-phone-circle","icon-phone-close","icon-persent","icon-phone1","icon-order-list","icon-paypal","icon-new-window","icon-option","icon-medicine","icon-man","icon-medical-kit","icon-male","icon-long-arrow-up","icon-long-arrow-right","icon-long-arrow-down","icon-long-arrow-left","icon-log-out","icon-list","icon-linked","icon-linux","icon-log-in","icon-link1","icon-library","icon-left-circle","icon-leaf","icon-lantern-o","icon-lantern","icon-ie","icon-hourglass","icon-html","icon-google","icon-good1","icon-git","icon-github-circle","icon-gly","icon-github","icon-font","icon-footprint","icon-flash","icon-finger-right","icon-finger-up","icon-firefox","icon-finger-down","icon-finger-left","icon-finger-click","icon-file-html","icon-file-css","icon-female","icon-expend","icon-expand","icon-euro","icon-file-edit","icon-download2","icon-edge","icon-down-circle","icon-down-chart","icon-douban","icon-file-cut","icon-dollar","icon-file-delete","icon-file-copy","icon-cut","icon-compress1","icon-coin-bag","icon-cloud-lighting","icon-compress","icon-file-close","icon-bad-o","icon-chrome","icon-file-check","icon-arrow-up-circle-o","icon-bicycle","icon-bad","icon-arrow-up-circle","icon-arrow-right-circle-o","icon-arrow-left-circle-o","icon-arrow-right-circle","icon-arrow-left-circle","icon-arrow-down-circle-o","icon-apple1","icon-application","icon-apple","icon-arrow-down-circle","icon-angle-double-up","icon-angle-double-left","icon-angle-double-right","icon-angle-double-down","icon-android","icon-amazon","icon-file-add","icon-alipay","icon-aliwanwan","icon--1","icon--","icon-airplane","icon-window","icon-wrench","icon-wifi","icon-warning-triangel","icon-warning-circle","icon-voice","icon-warning-circle-o","icon-voice-close","icon-trash","icon-users-o","icon-twitter","icon-user-round-o","icon-users","icon-user-round-circle-o","icon-user-round-circle","icon-user-o","icon-user","icon-update","icon-eject","icon-unlock","icon-touchmeter","icon-umberlla","icon-thinking","icon-temperature-empty","icon-temperature-full","icon-temperature-2","icon-temperature-1","icon-temperature-","icon-tags","icon-sun","icon-tag","icon-stop","icon-star-o","icon-step-forward","icon-step-backward","icon-star","icon-snow","icon-spinner","icon-smile","icon-square-o","icon-shutdown","icon-share-square-o","icon-share-square","icon-signal","icon-search-plus","icon-share-alt","icon-search-o","icon-search-minus","icon-search","icon-scope","icon-scissor-cut","icon-sad-o","icon-scissor","icon-refresh","icon-big-rain","icon-quote-right","icon-question-o","icon-quote","icon-quote-left","icon-question","icon-picture-delete","icon-printer","icon-play","icon-picture-close","icon-picture-add","icon-picture","icon-phone-o","icon-pencil","icon-phone","icon-pen","icon-pad-o","icon-pause","icon-exit-full-screen","icon-pad","icon-music-note","icon-movie","icon-music","icon-more-function","icon-mouse","icon-moment","icon-mobile-link-mobile","icon-mobile-o","icon-mobile-link-laptop","icon-mobile-link-computer","icon-minus-circle-o","icon-microphone-close","icon-microphone","icon-mobile","icon-messaging-o","icon-minus-circle","icon-minus","icon-messaging","icon-message-o","icon-message","icon-map","icon-mark-o","icon-mark","icon-loop","icon-magnet","icon-location-arrow-o","icon-lock","icon-loading-circle","icon-location-arrow","icon-location","icon-lightning","icon-link","icon-keyboard","icon-laptop-o","icon-laptop","icon-key","icon-information-o","icon-information","icon-id-card-o","icon-home-o","icon-id-card","icon-home","icon-headphone","icon-heart-o","icon-handshake","icon-heart","icon-good-o","icon-handbag","icon-handbag-o","icon-global","icon-hammer","icon-good","icon-gift","icon-game-ware","icon-game","icon-full-screen","icon-forward","icon-fork","icon-folder-open-o","icon-file-other","icon-folder-open","icon-folder-o","icon-feed","icon-save-o","icon-folder","icon-flag-o1","icon-flag-o","icon-flag1","icon-flag","icon-fire","icon-filter","icon-file-xls","icon-file-ps","icon-file-txt","icon-file-doc","icon-file-ai","icon-file","icon-facebook","icon-eye","icon-feather","icon-edit","icon-exchange","icon-email-open","icon-drawing-board","icon-email","icon-download","icon-diamond","icon-delete-o","icon-delete","icon-database-add","icon-database-o","icon-cubes1","icon-cubes","icon-database-delete","icon-database-close","icon-cube-o","icon-database","icon-cube1","icon-cube","icon-credit-card-o","icon-cpu","icon-copyright","icon-computer-o","icon-credit-card","icon-compass","icon-computer","icon-comments","icon-commenting","icon-commenting-o","icon-comment-o","icon-cog2-o","icon-cog-o","icon-command","icon-comment","icon-cog","icon-coffee","icon-cloud-sun","icon-clouds","icon-code","icon-close-rectangle-o","icon-close-square-o","icon-cloud","icon-clock","icon-close-square","icon-close-rectangle","icon-check-square-o","icon-close-circle","icon-circle-o","icon-close","icon-circle","icon-check-square","icon-check","icon-check-","icon-champion","icon-check-circle","icon-cart","icon-chart","icon-caret-up","icon-caret-right","icon-caret-left","icon-car","icon-taxi","icon-caret-down","icon-calculator","icon-calender","icon-camera","icon-bulb","icon-bug","icon-bus","icon-bomb","icon-brush","icon-battery-two","icon-bluetooth-o","icon-bell","icon-bluetooth","icon-birthday-cake","icon-bell-close","icon-battery-three","icon-battery-one","icon-battery-charging","icon-battery-full","icon-battery-empty","icon-battery-2","icon-battery-1","icon-battery-","icon-bar-v","icon-bars","icon-bar-h","icon-backward","icon-bar-code","icon-baby","icon-at","icon-arrows","icon-arrows-v","icon-arrows-alt","icon-arrows-h","icon-notice","icon-angle-up-o","icon-angle-up","icon-triangle-square-o","icon-angle-right-o","icon-angle-left","icon-angle-right","icon-angle-left-o","icon-angle-down-o","icon-angle-down","icon-align-justify","icon-align-right","icon-align-left","icon-align-center","icon-adjust-circle","icon-add-circle-o","icon-address-book-o","icon-address-book","icon-accessory","icon-add-circle","icon-add","icon-user-round","icon-f-text","icon-f-word","icon-f-powerpoint","icon-f-excel","icon-f-pdf","icon-f-image","icon-f-file","icon-f-archive","icon-f-audio","icon-loading","icon-signal-3","icon-signal-2","icon-signal-1","icon-signal-","icon-right-top-triangle","icon-left-top-triangle","icon-right-bottom-triangle","icon-left-bottom-triangle"],
      code3: `
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
      <title>yu-vue</title>
      <!--字体图标css-->
      <link rel="stylesheet" href="https://at.alicdn.com/t/font_657803_31srcimeac680k9.css">
      <!--字体图标css-->
    </head>
    <body>
      <div id="app"></div>
      <!-- built files will be auto injected -->
    </body>
  </html>
      `,
      code4: `
  <!-- <i class="iconfont 下方图标名称"> -->
  <i class="iconfont icon-home">
      `,
      code5: `
      `,
      code6: `
      `,
      code7: `
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'icon',
          description: '图标class',
          types: 'String',
          default: '无',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'click',
          description: '触发按钮点击事件',
          callback: '( event: Event )',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
      .icons-box{
        .icons{
          width: 100px;
          height: 80px;
          border: 1px solid $border;
          display: inline-block;
          margin: 0 -1px -1px 0;
          text-align: center;
          vertical-align: top;
          padding-top: 20px;
          i{
            font-size: 36px;
          }
          span{
            display: block;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/icon.vue